export default __webpack_public_path__ + "static/media/icon_protect.ac6724f7.png";